import { render, staticRenderFns } from "./reviewStatus.vue?vue&type=template&id=4473f528&scoped=true"
import script from "./reviewStatus.vue?vue&type=script&lang=js"
export * from "./reviewStatus.vue?vue&type=script&lang=js"
import style0 from "./reviewStatus.vue?vue&type=style&index=0&id=4473f528&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473f528",
  null
  
)

export default component.exports